import { HELP_CONTENT } from './helpContent.js';

function startsWithPath(prefix) {
  return (pathname) => pathname === prefix || pathname.startsWith(`${prefix}/`);
}

const registry = [
  {
    id: 'emission',
    matches: [
      '/guias/emitir',
      '/guias/emision',
      '/fojas/emision',
    ],
    content: HELP_CONTENT.emission,
  },
  {
    id: 'clients',
    matches: [
      '/administracion/clientes',
      '/admin/clientes',
      '/clientes',
    ],
    content: HELP_CONTENT.clients,
  },
  {
    id: 'tariffs',
    matches: [
      '/tarifas',
      '/administracion/tarifas',
    ],
    content: HELP_CONTENT.tariffs,
  },
];

function pathnameMatches(pathname, matcher) {
  if (typeof matcher === 'function') {
    return matcher(pathname);
  }
  return startsWithPath(matcher)(pathname);
}

export function getHelpEntry(pathname = '/') {
  const normalizedPathname = pathname || '/';
  const entry = registry.find((item) => item.matches.some((matcher) => pathnameMatches(normalizedPathname, matcher)));
  return entry?.content || HELP_CONTENT.generic;
}

export function getHelpRegistry() {
  return registry;
}

export default registry;
